module.exports = __webpack_public_path__ + "static/media/unknown.67ee23ad.svg";